import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "offcanvas-header mobile-navigation__header" }
const _hoisted_2 = { class: "mobile-navigation__brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mobile-navigation__identity" }
const _hoisted_5 = { class: "offcanvas-body mobile-navigation__body" }
const _hoisted_6 = { "aria-label": "Navegación móvil" }
const _hoisted_7 = ["disabled", "aria-expanded", "onClick"]
const _hoisted_8 = { class: "mobile-navigation__subnav" }
const _hoisted_9 = { class: "mobile-navigation__footer" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { Offcanvas } from 'bootstrap'
import { useRoute } from 'vue-router'
import logo from '@/assets/docbrain-logo-transparent.webp'
import type { NavigationGroup } from '@/config/navigation'
import type { AuthUser } from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavigation',
  props: {
    groups: {},
    user: {}
  },
  emits: ["logout"],
  setup(__props: any) {

const props = __props

const route = useRoute()
const offcanvasElement = ref<HTMLElement | null>(null)
const openGroups = ref(new Set<number>())
let instance: Offcanvas | null = null

const company = computed(() =>
  props.user?.organization?.trim() ||
  props.user?.receipt_profile?.business_name?.trim() ||
  ''
)
const routeMatches = (path: string) =>
  route.path === path || (path !== '/dashboard' && route.path.startsWith(`${path}/`))
const activeMenuRoute = computed(() =>
  props.groups
    .flatMap((group) => group.items)
    .filter((item) => routeMatches(item.route))
    .sort((first, second) => second.route.length - first.route.length)[0]?.route
)
const isActive = (path: string) => activeMenuRoute.value === path
const close = () => instance?.hide()
const openActiveGroups = () => {
  props.groups.forEach((group, index) => {
    if (group.items.some((item) => isActive(item.route))) openGroups.value.add(index)
  })
}
const toggleGroup = (index: number) => {
  if (props.groups[index].items.length === 0) return
  const next = new Set(openGroups.value)
  next.has(index) ? next.delete(index) : next.add(index)
  openGroups.value = next
}

onMounted(() => {
  if (offcanvasElement.value) instance = Offcanvas.getOrCreateInstance(offcanvasElement.value)
  openActiveGroups()
})
watch(() => route.path, openActiveGroups)
onBeforeUnmount(() => {
  instance?.dispose()
  instance = null
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "mobileNavigation",
    ref_key: "offcanvasElement",
    ref: offcanvasElement,
    class: "offcanvas offcanvas-start mobile-navigation",
    tabindex: "-1",
    "aria-labelledby": "mobileNavigationLabel"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(logo),
          alt: "",
          "aria-hidden": "true"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { id: "mobileNavigationLabel" }, "DocBrain", -1)),
          _createElementVNode("span", null, _toDisplayString(company.value || 'Gestión inteligente'), 1)
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("button", {
        type: "button",
        class: "btn-close btn-close-white",
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Cerrar menú"
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "mobile-navigation__avatar",
        "aria-hidden": "true"
      }, [
        _createElementVNode("i", { class: "fa-solid fa-user" })
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.user?.full_name || 'Usuario'), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.user?.email), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("nav", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, groupIndex) => {
          return (_openBlock(), _createElementBlock("section", {
            key: group.title || 'principal',
            class: "mobile-navigation__group"
          }, [
            (group.title)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "mobile-navigation__group-toggle",
                  type: "button",
                  disabled: group.items.length === 0,
                  "aria-expanded": openGroups.value.has(groupIndex),
                  onClick: ($event: any) => (toggleGroup(groupIndex))
                }, [
                  (group.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(group.icon),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(group.title), 1),
                  (group.items.length > 0)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: _normalizeClass(["fa-solid fa-chevron-down mobile-navigation__group-chevron", { 'mobile-navigation__group-chevron--open': openGroups.value.has(groupIndex) }]),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.route,
                  class: "mobile-navigation__link",
                  to: item.route,
                  "aria-current": isActive(item.route) ? 'page' : undefined,
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(item.icon),
                      "aria-hidden": "true"
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "aria-current"]))
              }), 128))
            ], 512), [
              [_vShow, !group.title || openGroups.value.has(groupIndex)]
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/perfil",
        class: "mobile-navigation__footer-link",
        onClick: close
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("i", {
            class: "fa-solid fa-user-gear",
            "aria-hidden": "true"
          }, null, -1),
          _createTextVNode(" Mi perfil ")
        ])),
        _: 1,
        __: [4]
      }),
      _createElementVNode("button", {
        type: "button",
        class: "mobile-navigation__footer-link mobile-navigation__footer-link--danger",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("i", {
          class: "fa-solid fa-right-from-bracket",
          "aria-hidden": "true"
        }, null, -1),
        _createTextVNode(" Cerrar sesión ")
      ]))
    ])
  ], 512))
}
}

})